import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-references',
    templateUrl: './references.component.html',
    styleUrls: ['./references.component.scss'],
    standalone: true
})
export class ReferencesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
